import React, { useContext, useState, useEffect } from 'react'
import { View, StyleSheet, SafeAreaView, ScrollView } from 'react-native'
import { UserContext } from '../../global/UserProvider'
import MainStats from './MainStats'
import TodayProductStats from './TodayProductStats'
import { Button } from '@ui-kitten/components'
import StatsListScreen from './StatsListScreen'
import { useTranslation } from 'react-i18next'
import { storesDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import StoreChooserHorizontal from '../../components/StoreChooserHorizontal'

export default function StatsScreen( { navigation, route } ) {
  const [context, setContext] = useContext(UserContext)
  const [store, setStore] = useState(context.user.store?.id)

  return (
    <ScrollView style={{flex: 1}}>
      <StatsListScreen style={styles.page} navigation={navigation} key="3" />
      <StoreChooserHorizontal store={store} style={{marginTop: 15}} showAll={false} onChange={(newStore) => {
        setStore(newStore)
      }} />
      <MainStats style={styles.page} key="1" store={store} navigation={navigation} />
      <TodayProductStats style={[styles.page, {marginBottom: 20}]} key="2" store={store} />
      <View style={{height: 50}}></View>
    </ScrollView>
  )
}


const styles = StyleSheet.create({
  page: {
    // justifyContent: 'center',
    // alignItems: 'center',
    // flex: 1,
    paddingHorizontal: 20,
  },
})
